import { createLazyFileRoute } from '@tanstack/react-router';

import { DefaultLayout } from '@src/layout';
import ServiceSupportPage from '@src/pages/Services/Support';

export const Route = createLazyFileRoute('/services/support')({
  component: ServiceSupportPageWithLayout,
});

function ServiceSupportPageWithLayout() {
  return (
    <DefaultLayout>
      <ServiceSupportPage />
    </DefaultLayout>
  );
}
